// eslint-disable-next-line import/prefer-default-export
export const CustomFieldValidationMixin = {
    data() {
        return {
            isCustomFieldsTouched: false
        };
    },
    methods: {
        /**
         * Validates that all required custom fields have values.
         * Sets isCustomFieldsTouched to true and returns whether validation passed.
         *
         * @param {Array} customFieldList - The list of custom fields to validate
         * @param {Object} customFieldValues - The object containing custom field values keyed by field name
         * @returns {boolean} - True if all required fields have values, false otherwise
         */
        $_validateRequiredCustomFields(customFieldList, customFieldValues) {
            this.isCustomFieldsTouched = true;
            let isValid = true;

            // Handle both flat arrays and nested arrays (like in FrequentAddressDetails)
            let allCustomFields = [];
            if (Array.isArray(customFieldList)) {
                const isNestedArray = customFieldList.length > 0 && Array.isArray(customFieldList[0]);
                allCustomFields = isNestedArray ? customFieldList.flat() : customFieldList;
            }

            if (allCustomFields.length > 0) {
                allCustomFields.forEach((customField) => {
                    if (customField.isRequired) {
                        const value = customFieldValues[customField.name];
                        if (value === null || value === undefined || value === '') {
                            isValid = false;
                        }
                    }
                });
            }
            return isValid;
        }
    }
};
